module.exports = __webpack_public_path__ + "img/lines-wanted.760b7fc1.png";